export default __webpack_public_path__ + "static/incident_image-209dc577416e611e5358a62679afd8dd.png";